import merge from "lodash.merge"
import Speedtest from "@frog/source/tests/utility/Speedtest.js"
import Geometry from "@frog/source/utility/Geometry.js"
import deepclone from "lodash.clonedeep"
import * as Objdict from "objdict"

import Unit from "@frog/source/models/Unit.js"
import Reactions from "@frog/source/models/Reactions.js"
import Selection from "@frog/source/models/Selection.js"
import World from "@frog/source/models/World.js"
import Zone from "@frog/source/models/Zone.js"
import Delta from "@frog/source/models/Delta.js"

// import worlds from "@frog/source/data/worlds.js"
const worlds = {}
// import chapters from "@frog/source/data/encounters/chapters.js" // imported for loading encounters.
import skills from "@frog/source/data/skills/skills.js"
// import * as deathzone from "@frog/source/data/deathzone.js"
import Step from "@frog/source/models/Step.js"
import Random from "@frog/source/utility/Random.js"

const MAX_INFLUENCE = 200 // TODO: this is duped from Unit.js

function fill(percentage, digits = 3) {
    if(digits == 0) {
        return ""
    }
    let string = ""
    string += Math.round(percentage * Math.pow(10, digits - 1))
    while(string.length < digits) {
        string = "0" + string
    }
    return string
}

export default class Stage {
    static load({stage, player, chapterParty, hasPreparePhase}) {
        stage = deepclone(stage)

        // if(stage.reference != undefined) {
        //     if(stages[stage.reference] == undefined) {
        //         throw "Could not find stage with reference " + stage.reference
        //     }
        //
        //     // TODO: Even if the stage is referenced, it should merge
        //     // any overriding child properties on top of the reference!
        //     // But it should do it intelligently, like merging units instead
        //     // of replacing units?
        //
        //     stage = stages[stage.reference]
        // }

        let units = []
        units = units.concat(Object.values(stage.units || [])) // HOW TO MERGE UNIT'S IN ENCOUNTER DATA AND TILEMAP UNITSPAWNS!!!
        units = units.concat(Object.values(stage.world.unitspawns))

        stage.units = units
        stage.units = Objdict.convert(stage.units)
        stage.units = Objdict.map(stage.units, (unit) => Unit.instantiate({unit, player, chapterParty}))

        if(hasPreparePhase == true) {
            Object.values(player.party.units).forEach((unit) => {
                stage.units[unit.key] = Unit.instantiate({player, chapterParty, "unit": {
                    "key": unit.key,
                    "position": {"x": -10, "y": -10, "z": 0},
                    "hasBeenRemoved": true,
                }})
            })
        }

        // // TODO: THIS SHOULDN'T JUST NUKE IT, IT SHOULD MERGE
        // // IT WITH ANY CHANGES...? THE PROTOSTAGE HAS DECLARED.
        // // ALSO, WE SHOULD MOVE THIS TO A WORLD STATIC LOAD CLASS!
        // if(stage.world.reference != undefined) {
        //     if(worlds[stage.world.reference] == undefined) {
        //         throw new Error("Could not find world with reference " + stage.world.reference)
        //     }
        //     let mergedWorld = deepclone(worlds[stage.world.reference])
        //
        //     const alteredWorld = {"reference": stage.world.reference}
        //     mergedWorld = merge(mergedWorld, alteredWorld)
        //
        //     // if(stage.world.terrain != undefined) {
        //     //     // const alteredTerrain = stage.world.terrain.map((terrain, key) => {
        //     //     //     if(terrain.position == undefined) {
        //     //     //         throw "Could not instantiate terrain without position"
        //     //     //     }
        //     //     //     terrain.position = terrain.position
        //     //     //     terrain.shape = terrain.shape || "block"
        //     //     //     terrain.z = terrain.position.z // AREN'T WE OBSOLETING THIS?
        //     //     //     terrain.key = terrain.key || terrain.position.x + "x" + terrain.position.y
        //     //     //     return terrain
        //     //     // })
        //     //     // console.log(alteredTerrain, mergedWorld)
        //     //     // mergedWorld.terrain = Objdict.merge(mergedWorld.terrain, alteredTerrain)
        //     // }
        //     // MERGE IN MORE PROPERTIES, BUT DEEPLY!!
        //
        //     stage.world = mergedWorld
        // }

        const NUMBER_OF_ENEMIES = 2
        const NUMBER_OF_SPAWNS = 1
        const NUMBER_OF_PLOTS = 8
        const TYPES_OF_ENEMIES = ["spider1"]
        const INNER_SPOTS = [
            {"position": {"x": 3, "y": 6, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 4, "y": 6, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 2, "y": 5, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 3, "y": 5, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 4, "y": 5, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 5, "y": 5, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 1, "y": 4, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 2, "y": 4, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 3, "y": 4, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 4, "y": 4, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 5, "y": 4, "z": 1}, "direction": Geometry.directions.south},
            {"position": {"x": 6, "y": 4, "z": 1}, "direction": Geometry.directions.south},
            {"position": {"x": 1, "y": 3, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 2, "y": 3, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 3, "y": 3, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 4, "y": 3, "z": 1}, "direction": Geometry.directions.south},
            {"position": {"x": 5, "y": 3, "z": 1}, "direction": Geometry.directions.south},
            {"position": {"x": 6, "y": 3, "z": 1}, "direction": Geometry.directions.south},
            {"position": {"x": 2, "y": 2, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 3, "y": 2, "z": 1}, "direction": Geometry.directions.south},
            {"position": {"x": 4, "y": 2, "z": 1}, "direction": Geometry.directions.south},
            {"position": {"x": 5, "y": 2, "z": 1}, "direction": Geometry.directions.south},
            {"position": {"x": 3, "y": 1, "z": 1}, "direction": Geometry.directions.south},
            {"position": {"x": 4, "y": 1, "z": 1}, "direction": Geometry.directions.south},
        ]
        const OUTER_SPOTS = [
            {"position": {"x": 5, "y": 1, "z": 1}, "direction": Geometry.directions.south},
            {"position": {"x": 6, "y": 1, "z": 1}, "direction": Geometry.directions.south},
            {"position": {"x": 6, "y": 2, "z": 1}, "direction": Geometry.directions.south},
            {"position": {"x": 7, "y": 3, "z": 1}, "direction": Geometry.directions.south},
            {"position": {"x": 7, "y": 4, "z": 1}, "direction": Geometry.directions.south},
            {"position": {"x": 6, "y": 5, "z": 1}, "direction": Geometry.directions.south},
            {"position": {"x": 6, "y": 6, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 5, "y": 6, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 4, "y": 7, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 3, "y": 7, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 2, "y": 6, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 1, "y": 6, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 1, "y": 5, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 0, "y": 4, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 0, "y": 3, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 1, "y": 2, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 1, "y": 1, "z": 1}, "direction": Geometry.directions.east},
            {"position": {"x": 2, "y": 1, "z": 1}, "direction": Geometry.directions.south},
            {"position": {"x": 3, "y": 0, "z": 1}, "direction": Geometry.directions.south},
            {"position": {"x": 4, "y": 0, "z": 1}, "direction": Geometry.directions.south},
        ]

        if(hasPreparePhase == true) {
            const innerspots = Random.shuffle(INNER_SPOTS)
            const outerspots = Random.shuffle(OUTER_SPOTS)
            for(let i = 0; i < NUMBER_OF_SPAWNS; i += 1) {
                const spot = outerspots.pop()
                stage.units["spawn" + i] = Unit.instantiate({player, chapterParty, "unit": {
                    "key": "spawn" + i,
                    "position": spot.position,
                    "direction": spot.direction,
                    "class": "spawn-zone",
                    "spawnclass": Random.element(TYPES_OF_ENEMIES),
                }})
            }
            for(let i = 0; i < NUMBER_OF_ENEMIES; i += 1) {
                const spot = innerspots.pop()
                stage.units["enemy" + i] = Unit.instantiate({player, chapterParty, "unit": {
                    "key": "enemy" + i,
                    "position": spot.position,
                    "direction": spot.direction,
                    "class": Random.element(TYPES_OF_ENEMIES),
                    "affiliation": "bad",
                }})
            }
            for(let i = 0; i < NUMBER_OF_PLOTS; i += 1) {
                const spot = innerspots.pop()
                const block = stage.world.blocks[spot.position.x + "x" + spot.position.y + "x0"]
                block.image = require("@frog/source/assets/images/apocalypse-tactics/environment/tiles/tileFarm_farmPlot.png").default
                block.images = [block.image]
                block.imageVariants = [
                    require("@frog/source/assets/images/apocalypse-tactics/environment/tiles/tileFarm_farmPlot.png").default,
                    require("@frog/source/assets/images/apocalypse-tactics/environment/tiles/tileFarmSunset_farmPlot.png").default,
                    require("@frog/source/assets/images/apocalypse-tactics/environment/tiles/tileFarmNight_farmPlot.png").default,
                ]
                block.type = "plot"
            }
            for(let i = 0; i < Random.element([1, 1, 2]); i += 1) {
                const spot = innerspots.pop()
                stage.units["wildplant" + i] = Unit.instantiate({player, chapterParty, "unit": {
                    "key": "wildplant" + i,
                    "position": spot.position,
                    "class": "kiwisquash",
                    "level": 2,
                }})
            }
        }

        stage.turn = {"number": 0, "affiliation": "good"}
        // stage.actionMark = 0
        // stage.zone = 0

        // stage.success = stage.success || {"type": "defeat-all-units"} // TODO: qualify this as the player's success?
        // stage.failure = stage.failure || {"type": "defeat-all-units"} // TODO: qualify this as the player's failure?

        // TODO: Even if a stage is passed, search it for properties
        // that need to be deserialized or defaulted like base stats on units!
        // Or maybe the stage is defined but the map is a reference.

        return stage
    }
    static findUnitAtPosition(stage, position, options) {
        return Stage.findUnitsByPosition(stage, position, options)[0]
    }
    static findUnitByPosition(stage, position, options = {}) {
        return Stage.findUnitsByPosition(stage, position, options)[0]
    }
    static findUnitsByPosition(stage, position, options = {}) {
        if(options.excludeUnitKey instanceof Array == false) {
            if(options.excludeUnitKey != undefined) {
                options.excludeUnitKey = [options.excludeUnitKey]
            } else {
                options.excludeUnitKey = []
            }
        }
        return Object.values(stage.units).filter((unit) => {
            if(unit.isDead) return false
            if(unit.hasBeenRemoved) return false
            if(options.excludeUnitKey.includes(unit.key)) return false
            if(unit.type == "zone") {
                if(!(options.includingSpawnZones && unit.type == "spawn-zone")
                || !options.includingZones) {
                    return false
                }
            }
            return unit.position.x == position.x
                && unit.position.y == position.y
                // && unit.position.z == position.z
        })
    }
    static findUnitInDirection(stage, position, direction, range) {
        let distance = 0
        let previousPosition = Geometry.add(position, {"x": 0, "y": 0})
        let nextPosition = Geometry.add(position, direction)

        while(Stage.hasCollision({stage, previousPosition, nextPosition, "options": {"isIgnoringLedges": true}}) == false) {
            distance += 1
            if(range != undefined && distance >= range.max) break
            vector = Geometry.multiply(direction, distance)
            previousPosition = Geometry.add(position, vector)
            nextPosition = Geometry.add(position, vector, direction)
        }

        // if(distance == 0) couldn't go far in any direction, but did find a direction
        if(World.hasCollision2({
            "world": stage.world, previousPosition, nextPosition,
            "options": {"isIgnoringLedges": true},
            "zone": stage.encounters[stage.currentEncounter || 1].zone,
        }) == true) {
            // FOUND A COLLISION
        } else if(Stage.findUnitByPosition(stage, nextPosition) != undefined) {
            return Stage.findUnitByPosition(stage, nextPosition)
        }
    }
    // returns a collision raycast.
    // the positions are a raycast. the end position is the last good position before the collision position.
    // startPosition -----> endPosition || collisionPosition
    // can return no collision if a maxdistance is provided.
    // ignores any collision on the tile it is leaving from
    static findCollisionInDirection({stage, position, direction, maxdistance=Infinity, options}) {
        const ray = {
            "startPosition": position,
            "direction": direction,

            "endPosition": Geometry.copy(position),
            "vector": {"x": 0, "y": 0},
            "distance": 0,

            "positions": [], // THIS ONE INCLUDES THE COLLISION!!
            "castedPositions": [], // THIS ONE DOES NOT INCLUDE THE COLLISION, AND INCLUDES THE CAST START LOCATION
        }

        while(ray.distance < maxdistance) {
            const previousPosition = ray.endPosition
            const nextPosition = Geometry.add(ray.endPosition, ray.direction)
            ray.positions.push(nextPosition)
            ray.castedPositions.push(previousPosition)

            const collision = Stage.findCollision({stage, previousPosition, nextPosition, options})
            if(collision != undefined) {
                ray.collisionPosition = nextPosition
                ray.collision = collision
                break
            }

            ray.distance += 1
            ray.vector = Geometry.add(ray.vector, direction)
            ray.endPosition = Geometry.add(ray.endPosition, direction)

            if(ray.distance >= maxdistance) {
                ray.castedPositions.push(nextPosition)
                break
            }
        }

        return ray
    }
    static findCollision({stage, previousPosition, nextPosition, options}) {
        if(World.hasCollision2({
            "world": stage.world,
            "previousPosition": previousPosition,
            "nextPosition": nextPosition,
            "options": options,
            "zone": stage.encounters[stage.currentEncounter || 1].zone,
        })) {
            return {"type": "world", "position": nextPosition}
        }
        const unit = Stage.findUnitByPosition(stage, nextPosition)
        if(unit != undefined) {
            return {"type": "unit", "position": nextPosition, "unit": unit}
        }
    }
    static hasCollision({stage, previousPosition, nextPosition, position, options}) {
        nextPosition = nextPosition || position
        previousPosition = previousPosition || position
        if(World.hasCollision2({
            "world": stage.world,
            "previousPosition": previousPosition,
            "nextPosition": nextPosition,
            "options": options,
            "zone": stage.encounters[stage.currentEncounter || 1].zone,
        })) {
            return true
        }
        if(Stage.findUnitByPosition(stage, nextPosition, options)) {
            return true
        }
        return false
    }

    static hasMetCondition(stage, condition, zone) {
        if(condition == undefined
        || stage == undefined) {
            return false
        }
        if(condition.type == "exit") {
            const units = Object.values(stage.units).filter((unit) => {
                return unit.affiliation == condition.affiliation
                    && (zone == undefined || Zone.isInBounds(zone, unit.position))
            })
            const remainingUnits = units.filter((unit) => unit.isDead != true && unit.hasBeenRemoved != true)
            const removedUnits = units.filter((unit) => unit.hasBeenRemoved)
            if(removedUnits.length > 0
            && remainingUnits == 0) {
                return true
            }
            return false
        }
        if(condition.type == "defeat-unit"
        && condition.unitKey != undefined) {
            return stage.units[condition.unitKey] != undefined
                && stage.units[condition.unitKey].isDead == true
        }
        if(condition.type == "defeat-all-other-units"
        && condition.unitKey !== undefined) {
            const remainingUnits = Object.values(stage.units).filter((unit) => {
                return unit.isDead != true
                    && unit.hasBeenRemoved != true
                    && (zone == undefined || Zone.isInBounds(zone, unit.position))
            })
            return remainingUnits.length == 1
                && remainingUnits[0].key == condition.unitKey
        }
        if(condition.type == "defeat-all-unaffiliated-units"
        && condition.affiliation !== undefined) {
            const undefeatedUnit = Objdict.find(stage.units, (unit) => {
                return unit.affiliation != condition.affiliation
                    && unit.affiliation != "none"
                    && unit.isDead != true
                    && (zone == undefined || Zone.isInBounds(zone, unit.position))
            })
            return undefeatedUnit == undefined
        }
        if(condition.type == "wait-x-turns"
        && condition.turnNumber != undefined) {
            return stage.turn.number >= condition.turnNumber
        }
    }

    static copy(alphastage) {
        const omegastage = {
            "units": Objdict.map(alphastage.units, (unit) => Unit.copy(unit)),
            "world": alphastage.world,

            "turn": {
                "number": alphastage.turn && alphastage.turn.number || 0,
                "affiliation": alphastage.turn && alphastage.turn.affiliation,
            },
            "tags": Objdict.map(alphastage.tags || {}, (tag) => {
                return {
                    "name": tag.name,
                    "value": tag.value,
                }
            }),
            // "zone": alphastage.zone,
            // "actionMark": alphastage.actionMark, // we still using this?
            // "light": alphastage.light,


            "encounters": alphastage.encounters,
            "currentEncounter": alphastage.currentEncounter,
            // TO DEPRECATE, ALL OF THE BELOW:
            "events": alphastage.events,
            "conditions": alphastage.conditions,
            "success": alphastage.success,
            "failure": alphastage.failure,
            "dialogue": alphastage.dialogue,
            "prompt": alphastage.prompt,
        }
        // TODO: suport a less embedded test stubbing for skill id gen???
        if(alphastage.idgen !== undefined) {
            omegastage.idgen = alphastage.idgen
        }
        return omegastage
    }

    //////////////
    // SCORING //
    ////////////

    // static deltascore(alphastage, omegastage, affiliation) {
    //     const TARGET_PRIORITY = {
    //         "good": 100,
    //         "bad": 100,
    //         "none": 50,
    //     }
    //     const alphascore = Stage.score(alphastage, affiliation)
    //     const omegascore = Stage.score(omegastage, affiliation)
    //     let score = alphascore - omegascore
    //     // score = Math.min(1, score / MAX_SCORE)
    //
    //     return score
    // }

    // Does not (yet) set the action.score, just returns the score.
    // Lets you pass in a different stage from action.stage for predictive logic.
    static score({action, stage, affiliation}) {
        stage = stage || action.omegastage

        const scores = {}

        // INFLUENCES //
        let influenceScore = 0
        // let influenceCount = 0
        if(action.influenceMap != undefined) {
            const omegaperformer = stage.units[action.performerKey]

            influenceScore = Stage.getInfluenceScore(action.influenceMap, omegaperformer.position)
            // influenceCount += 1

            // if(omegaperformer.effects != undefined) {
            //     Objdict.forEach(omegaperformer.effects, (effect) => {
            //         if(effect.type == "trap") {
            //             effect.positions.forEach((position) => {
            //                 influenceScore += Stage.getInfluenceScore(action.influenceMap, position)
            //                 influenceCount += 1
            //             })
            //         }
            //     })
            // }
        }

        // Note well! A smaller influence percent is a better influence!!
        scores.influence = influenceScore / MAX_INFLUENCE // (MAX_INFLUENCE * influenceCount)

        // ACTION TYPE //

        scores.type = action.type

        // PROGRESS TOWARDS GOALS //
        const progress = {}
        progress["enemy"] = {"maxhealth": 0, "health": 0, "maxcount": 0, "count": 0}
        progress["ally"] = {"maxhealth": 0, "health": 0, "maxcount": 0, "count": 0}
        Objdict.forEach(stage.units, (unit) => {
            progress[unit.affiliation] = progress[unit.affiliation] || {
                "maxhealth": 0, "health": 0, "maxcount": 0, "count": 0
            }
            progress[unit.affiliation].maxhealth += unit.maxhealth
            progress[unit.affiliation].health += unit.health
            progress[unit.affiliation].maxhealth += unit.maxarmor || 0
            progress[unit.affiliation].health += unit.armor || 0
            progress[unit.affiliation].maxcount += 1
            progress[unit.affiliation].count += 1

            if(unit.isDead == true) {
                progress[unit.affiliation].count -= 1
            }

            if(unit.affiliation != "none") {
                let relationship = undefined
                if(unit.affiliation == affiliation) {
                    relationship = "ally"
                } else {
                    relationship = "enemy"
                }

                progress[relationship].maxhealth += unit.maxhealth
                progress[relationship].health += unit.health
                progress[relationship].maxhealth += unit.maxarmor || 0
                progress[relationship].health += unit.armor || 0
                progress[relationship].maxcount += 1
                progress[relationship].count += unit.isDead ? 0 : 1
            }
        })

        scores["enemy"] = {
            "count": progress["enemy"].count / progress["enemy"].maxcount,
            "health": progress["enemy"].health / progress["enemy"].maxhealth,
            "progress": progress["enemy"],
        }
        scores["ally"] = {
            "count": progress["ally"].count / progress["ally"].maxcount,
            "health": progress["ally"].health / progress["ally"].maxhealth,
            "progress": progress["ally"],
        }
        if(progress["none"] != undefined) {
            scores["none"] = {
                "count": progress["none"].count / progress["none"].maxcount,
                "health": progress["none"].health / progress["none"].maxhealth,
                "progress": progress["none"],
            }
        }

        // All other factions are considered an enemy faction and will be targeted.
        // Do we want to eventually let factions by allies to each other? Like the
        // green faction won't target your units, but you don't control them? Then
        // we'll need a faction data set for who targets who.
        // The none faction is an exception. Is neither ally or enemy. Is this a
        // faction that is considered a lesser target? Are they still targetable
        // by a faction in the who targets who? The same might apply for other
        // factions later, like a red ai who targets your blue faction over the
        // npc green faction

        return scores
    }
    static getInfluenceScore(influenceMap, position) {
        return influenceMap[position.x + "x" + position.y]
    }
    static flattenActionMap(actionmap) {
        let actions = []
        Objdict.forEach(actionmap, (actionmaplist) => {
            actions = actions.concat(actionmaplist)
        })
        return actions
        // // By flattening a unit's action map, each possible position
        // // will have one and only one action, scored as the "best."
        // // In most cases, this is just different directions of approaching
        // // that same action type from different previous positions.
        // return Objdict.map(actionmap, (actionmaplist) => {
        //     return actionmaplist[0]
        // })
    }
    // Stage.isBetterScore(a, b)
    // returns true if (a) is a better score than (b)
    static isBetterScore(a, b, unit) {
        if(a.none != undefined && b.none != undefined) {
            if(a.none.count < b.none.count) return true
            if(a.none.count > b.none.count) return false
            if(a.none.health < b.none.health) return true
            if(a.none.health > b.none.health) return false
        }

        if(a.enemy.count < b.enemy.count) return true
        if(a.enemy.count > b.enemy.count) return false
        if(a.enemy.health < b.enemy.health) return true
        if(a.enemy.health > b.enemy.health) return false

        if(unit.state != "idle") {
            if(a.influence > b.influence) return true
            if(a.influence < b.influence) return false
        }

        if(a.ally.count > b.ally.count) return true
        if(a.ally.count < b.ally.count) return false
        if(a.ally.health > b.ally.health) return true
        if(a.ally.health < b.ally.health) return false

        // if(a.none ? a.none.count : 0 < b.none ? b.none.count : 0) return true
        // if(a.none ? a.none.count : 0 > b.none ? b.none.count : 0) return false

        const types = ["invoke skill", "move", "wait-for-move"]
        if(types.indexOf(a.type) > types.indexOf(b.type)) return true
        if(types.indexOf(a.type) < types.indexOf(b.type)) return false
        // scores.byActionType = 0
        // if(action.type == "move through") {
        //     scores.byActionType = -1 // to be skipped!!
        // } else if(action.type == "invoke skill") {
        //     scores.byActionType = 1
        // } else if(action.type == "move") {
        //     scores.byActionType = 2
        // }

        if(a.distance < b.distance) return -1
        if(a.distance > b.distance) return +1

        // TODO: filter out a and b for .type == -1?
        // or just leave that to a separate isInvalidAction?
    }
    static isInvalidAction(action) {
        // TODO: why do we even keep these invalid actions around?
        if(action.type == "move through") {
            return true
        }
    }

    ////////////////
    // NEXT TURN //
    //////////////

    static calculateNextTurn(stage, options = {}) {
        const {aiActions, steps} = Stage.getNonPlayerSteps(stage, options)

        stage.nextTurn = {
            "aiActions": aiActions,
            "steps": steps,
            "omegastage": steps[steps.length - 1].omegastage
        }
    }
    static getNonPlayerSteps(stage, options = {}) {
        let steps = []

        // // HEY!! WHY ISN'T THIS DOUBLED FOR THE OTHER END OF TURN???
        // steps = steps.concat(Stage.getEndOfTurnTileSteps(stage))
        // stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEndOfTurnSkillSteps(stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEnergyRefresh(stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        // if(Stage.hasMetCondition(stage, stage.success)) {
        //     steps = steps.concat(Stage.getSuccessSteps(stage))
        //     return {steps}
        // } else if(Stage.hasMetCondition(stage, stage.failure)) {
        //     steps = steps.concat(Stage.getFailureSteps(stage))
        //     return {steps}
        // }

        if(stage.encounters[stage.currentEncounter || 1] != undefined
        && stage.encounters[stage.currentEncounter || 1].conditions != undefined) {
            const encounter = stage.encounters[stage.currentEncounter || 1]
            encounter.conditions.forEach((condition) => {
                if(Stage.hasMetCondition(stage, condition, encounter.zone)) {
                    if(condition.events != undefined) {
                        steps = steps.concat(Stage.processEventSteps(stage, condition.events))
                        stage = steps[steps.length-1]?.omegastage || stage
                    }
                }
            })
            // // if has moved to new encounter
            // const nextEncounter = stage.encounters[stage.currentEncounter || 1]
            // if(encounter != nextEncounter) {
            //     steps = steps.concat(Stage.getEventSteps(stage, "turn:0:start"))
            //     stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage
            //     return {steps}
            // }
        }

        steps = steps.concat(Stage.getEventSteps(stage, "turn:" + stage.turn.number + ":end"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:every:end"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:every-even:end"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getStartTurnSteps("bad", stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:" + stage.turn.number + ":start"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:every:start"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:every-odd:start"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        let aiActions = []
        const aiAffiliations = ["bad"] //, "undead", "neutral"]
        if(options.ignoreAI != true) {
            aiAffiliations.forEach((affiliation) => {
                const ai = Stage.getAiSteps(affiliation, stage)
                aiActions = aiActions.concat(ai.actions) // for returning from this function
                steps = steps.concat(ai.steps)
                stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage
            })
        }

        steps = steps.concat(Stage.getEndOfTurnSkillSteps(stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:" + stage.turn.number + ":end"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:every:end"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:every-odd:end"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEnergyRefresh(stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        // if(Stage.hasMetCondition(stage, stage.success)) {
        //     steps = steps.concat(Stage.getSuccessSteps(stage))
        //     return {steps, aiActions}
        // } else if(Stage.hasMetCondition(stage, stage.failure)) {
        //     steps = steps.concat(Stage.getFailureSteps(stage))
        //     return {steps, aiActions}
        // }
        if(stage.encounters[stage.currentEncounter || 1] != undefined
        && stage.encounters[stage.currentEncounter || 1].conditions != undefined) {
            const encounter = stage.encounters[stage.currentEncounter || 1]
            encounter.conditions.forEach((condition) => {
                if(Stage.hasMetCondition(stage, condition, encounter.zone)) {
                    if(condition.events != undefined) {
                        steps = steps.concat(Stage.processEventSteps(stage, condition.events))
                        stage = steps[steps.length-1]?.omegastage || stage
                    }
                }
            })
            if(encounter != stage.encounters[stage.currentEncounter || 1]) {
                return {steps, aiActions}
            }
        }
        // if(stage.conditions != undefined) {
        //     stage.conditions.forEach((condition) => {
        //         if(Stage.hasMetCondition(stage, condition)) {
        //             steps = steps.concat(Stage.processEventSteps(stage, condition.events))
        //             stage = steps[steps.length-1]?.omegastage || stage
        //         }
        //     })
        //     if(stage.isDone == true) {
        //         return {steps, aiActions}
        //     }
        // }

        steps = steps.concat(Stage.getStartTurnSteps("good", stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:" + stage.turn.number + ":start"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:every:start"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, "turn:every-odd:start"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        // DECREASE EFFECT DURATION

        // actions = actions.concat(Stage.getEventActions(this.events[(this.turn.number + 2) + ":start"]))
        // actions = actions.concat(Stage.getWorldActions("good", shadowunits))

        return {steps, aiActions}
    }
    static getEnergyRefresh(stage) {
        return [
            Step.instantiate({
                "type": "refresh",
                "alphastage": stage,
                "deltastages": [
                    {
                        "units": Objdict.map(stage.units, (unit) => {
                            return {
                                "energy": {"move": true, "invoke skill": true},
                            }
                        })
                    }
                ]
            })
        ]
    }
    static getStartTurnSteps(affiliation, stage) {
        const steps = [
            Step.instantiate({
                "type": "start turn",
                "affiliation": affiliation,
                "alphastage": stage,
                "deltastages": []
            }),
        ]
        steps.push(Step.instantiate({
            "type": "refresh",
            "alphastage": stage,
            "deltastages": [
                {
                    "turn": {
                        "number": stage.turn.number + 1,
                        "affiliation": affiliation,
                    },
                }
            ]
        }))
        return steps
    }
    static getEndOfTurnTileSteps(stage) {
        const steps = []
        let alphastage = stage
        // if(stage.success != undefined
        // && stage.success.condition == "escape") {
        //     stage.success.positions.forEach((position) => {
        //         Objdict.forEach(alphastage.units, (unit) => {
        //             if(unit.isDead != true
        //             && Geometry.equals(unit.position, position)
        //             && unit.affiliation == stage.success.affiliation) {
        //                 const step = Step.instantiate({
        //                     "type": "escape",
        //                     "alphastage": alphastage,
        //                     "deltastages": [{
        //                         "annotation": {"type": "escape", "startPosition": unit.position},
        //                         "units": {
        //                             [unit.key]: {
        //                                 "isDead": true,
        //                                 "hasBeenRemoved": true,
        //                             }
        //                         }
        //                     }]
        //                 })
        //
        //                 alphastage = step.omegastage
        //                 steps.push(step)
        //             }
        //         })
        //     })
        // }
        return steps
    }
    static getEndOfTurnSkillSteps(stage, options = {}) {
        const steps = []
        let alphastage = stage

        // TODO: what is the order of unit and skills at the end-of-turn?
        Objdict.forEach(stage.units, (unit) => {
            const alphaunit = alphastage.units[unit.key]
            if(alphaunit.isDead == true) return
            if(alphaunit.hasBeenRemoved == true) return
            Objdict.forEach(unit.effects, (effect, effectKey) => {
                const alphaeffect = alphaunit.effects[effectKey]
                if(alphaeffect.timer != undefined) {
                    if(alphaeffect.timer - 1 <= 0) {
                        // if(alphaeffect.type == "fuse"
                        // && alphaeffect.skillKey != undefined
                        // && skills.get(alphaeffect.skillKey) != undefined) {
                        //     const step = skills.get(alphaeffect.skillKey).calculateStep({
                        //         "performerKey": alphaunit.key,
                        //         "effectKey": effectKey,
                        //         "position": alphaunit.position,
                        //         "stage": alphastage,
                        //     })
                        //     step.skillKey = alphaeffect.skillKey
                        //     step.type = "invoke skill"
                        //
                        //     Objdict.forEach(step.omegastage.units, (unit) => {
                        //         if(unit.health <= 0
                        //         && unit.isDead != true) {
                        //             Step.add(step, {"units": {[unit.key]: {"isDead": true}}})
                        //         }
                        //     })
                        //
                        //     alphastage = step.omegastage
                        //     steps.push(step)
                        // } else {
                        const step = Step.instantiate({
                            "type": "remove effect",
                            "alphastage": alphastage,
                            "deltastages": [{
                                "units": {
                                    [alphaunit.key]: {
                                        "effects": {
                                            [effectKey]: undefined
                                        }
                                    }
                                }
                            }]
                        })

                        alphastage = step.omegastage
                        steps.push(step)
                    } else {
                        const step = Step.instantiate({
                            "type": "decrement effect timer",
                            "alphastage": alphastage,
                            "deltastages": [{
                                "units": {
                                    [alphaunit.key]: {
                                        "effects": {
                                            [effectKey]: { // TODO: why isn't alphaeffect.key not defined :<
                                                "timer": alphaeffect.timer - 1,
                                            }
                                        }
                                    }
                                }
                            }]
                        })

                        alphastage = step.omegastage
                        steps.push(step)
                    }
                }

                // // this doesn't work, for whatever reason.
                // // just going to do something different.
                if(alphaeffect.type == "at-end-of-turn"
                && alphaeffect.skillKey != undefined) {
                    const skill = skills.get(alphaeffect.skillKey)
                    if(skill != undefined) {
                        if(skill.canTarget instanceof Function == false
                        || skill.canTarget({"performerKey": alphaunit.key, "position": alphaunit.position, "stage": alphastage}) == true) {
                            if(skill.calculateDeltastages instanceof Function) {
                                const step = Step.instantiate({
                                    "type": "invoke skill",
                                    "alphastage": alphastage,
                                    "skillKey": alphaeffect.skillKey, // wait do i still need to do this? i don't think we do.
                                    "deltastages": skill.calculateDeltastages({
                                        "performerKey": alphaunit.key, // wait, you're performing it on yourself? because it's your effect?
                                        "position": alphaunit.position,
                                        "stage": alphastage,
                                    })
                                })
                            } else if(skill.calculateStep instanceof Function) {
                                step = skill.calculateStep({
                                    "performerKey": alphaunit.key,
                                    "position": alphaunit.position,
                                    "stage": alphastage,
                                })
                            }

                            alphastage = step.omegastage
                            steps.push(step)
                        }
                    }
                }
            })
            Objdict.forEach(alphaunit.equippedSkills, (skillKey) => {
                const skill = skills.get(skillKey)
                if(skill != undefined) {
                // && (alphastage.turn.number + (options.turnNumber || 0)) % 2 == 1) {
                // && (alphaunit.affiliation == "good" && alphastage.turn.number % 2 == 0
                // || alphaunit.affiliation == "bad" && alphastage.turn.number % 2 != 0)) {
                    if(skill.type == "at-end-of-turn"
                    || (skill.type == "at-end-of-my-turn" && alphastage.turn.affiliation == alphaunit.affiliation)
                    || (skill.type == "at-end-of-player-turn" && alphastage.turn.affiliation == "good")) {
                        if(skill.canTarget instanceof Function == false
                        || skill.canTarget({"performerKey": alphaunit.key, "position": alphaunit.position, "stage": alphastage}) == true) {
                            let step = undefined
                            if(skill.calculateDeltastages instanceof Function) {
                                step = Step.instantiate({
                                    "type": "invoke skill",
                                    "alphastage": alphastage,
                                    "skillKey": skillKey, // I hate this
                                    "deltastages": skill.calculateDeltastages({
                                        "performerKey": alphaunit.key,
                                        "position": alphaunit.position,
                                        "stage": alphastage,
                                    })
                                })
                            } else if(skill.calculateStep instanceof Function) {
                                step = skill.calculateStep({
                                    "performerKey": alphaunit.key,
                                    "stage": alphastage,
                                })
                            }

                            // TODO: this is making a step & animation
                            // for every unitzone that has this skill.
                            // can we return undefined if there is
                            // no step to be performed?

                            alphastage = step.omegastage
                            steps.push(step)
                        }
                    }
                }
            })
        })

        // deaths and stuff:
        steps.concat(Reactions.getSteps(stage))

        return steps
    }

    static getAiSteps(affiliation, stage) {
        const turn = {
            "steps": [],
            "actions": {} // by unit key
        }

        const units = []
        Objdict.forEach(stage.units, (unit) => {
            if(unit.affiliation == affiliation
            && unit.isDead != true
            && Zone.isInBounds(stage.encounters[stage.currentEncounter || 1].zone, unit.position)) {
                units.push(unit)
            }
        })

        let alphastage = stage
        units.forEach((unit) => {
            const actionmap = Unit.calculateActions(unit.key, alphastage) // we really recalculating this huh
            let actions = Stage.flattenActionMap(actionmap)

            if(actions.length == 0) return

            actions.sort((a, b) => {
                if(a.distance < b.distance) return -1
                if(a.distance > b.distance) return +1
                return 0
            })

            let bestAction = undefined
            actions.forEach((action) => {
                if(Stage.isInvalidAction(action)) {
                    return action
                }

                // TODO: This should be far less verbose... Pull in the Step.js class?? as Sequence.js?
                // action.predictiveSteps = action.steps.concat(Stage.getEndOfTurnSkillSteps(action.omegastage))
                // action.predictiveOmegastage = action.predictiveSteps[action.predictiveSteps.length-1].omegastage
                // // action.predictiveSteps = action.predictiveSteps.concat(Stage.getEndOfTurnSkillSteps(action.predictiveOmegastage, {"turnNumber": +1}))
                // // action.predictiveOmegastage = action.predictiveSteps[action.predictiveSteps.length-1].omegastage

                action.score = Stage.score({
                    "stage": action.omegastage,
                    // "stage": action.predictiveOmegastage, // ADDED FOR BOMBER
                    "action": action,
                    "affiliation": affiliation,
                    "unit": unit,
                })

                if(action.type == "move through") {
                    return
                }

                if(bestAction == undefined
                || Stage.isBetterScore(action.score, bestAction.score, unit)) {
                    bestAction = action
                }
            })
            if(bestAction != undefined) {
                turn.actions[unit.key] = {"action": bestAction, "actionmap": actionmap}
                turn.steps = turn.steps.concat(bestAction.steps)
                alphastage = turn.steps[turn.steps.length-1].omegastage
            }
        })

        return turn

        // TODO: Address the hangover of returning actions alongside steps.
        // We need them to render the enemy ui. We really just use action type
        // and action position. We are currently hurting because we're not
        // returning the entire action map (to show enemy range). We need to
        // eventually include order of actions as well, to match the order
        // of steps, so we can maybe animate the enemy intention ui with some
        // slight order-of-operations delay in how it renders out.

        // RECENT //

        // const affiliatedUnits = {}
        // let steps = []
        // let alphastage = stage
        // Objdict.forEach(stage.units, (unit) => {
        //     const alphaunit = alphastage.units[unit.key]
        //     if(alphaunit.affiliation == "bad"
        //     && alphaunit.isDead != true) {
        //         const actionmap = Unit.calculateActions(unit.key, alphastage)
        //         const action = Unit.getBestAction(actionmap)
        //         steps = steps.concat(action.steps)
        //         affiliatedUnits[unit.key] = {action, actionmap}
        //
        //         if(action != undefined) {
        //             alphastage = action.omegastage
        //         }
        //     }
        // })
        // // TODO: ONCe WE HAVE THE BEST ACTION, WE CAN PROBABLY DUMP ALLLLL THE OTHER POSSIBILITIES AS USELESS.
        // return {"affiliatedUnits": affiliatedUnits, "affiliatedSteps": steps}

        // OLDER //

        // this.influence[affiliation] = this.getInfluence(affiliation, shadowunits)
        // TODO: uuuuh if there is any meaningful state change in stage vs
        // alphastagewithheavycomputation, then we need to recompute here.

        // // this is so wasteful, given that
        // // alphastage at the start of this getnonplyaeractions process should have already
        // // computed all of this. or most of this (it doesn't have the start of turn state
        // // changes like effects wearing off)
        // // UUH IS THIS STILL TRUE I REFACTORED IT SO IT ONLY CALCULATES ONCE
        //
        // Objdict.forEach(stage.units, (unit) => {
        //     if(unit.affiliation == affiliation && unit.isDead != true) {
        //         steps = steps.concat(unit.bestAction.steps)
        //         // THIS DOES NOT RESPECT THE ORDER OF THE
        //         // BEST ACTIONS, SO IF YOU EVER CHANGE IT
        //         // SO UNIT ORDER IS DYNAMIC, THIS MUST BE
        //         // RESTRUCTURED ACCORDINGLY
        //     }
        // })
    }
    static getEventSteps(stage, eventKey) {
        if(stage == undefined
        || stage.encounters == undefined
        || stage.encounters[stage.currentEncounter || 1] == undefined) {
            return []
        }

        const encounter = stage.encounters[stage.currentEncounter || 1]

        if(encounter.conditions != undefined) {
            const condition = encounter.conditions.find((condition) => condition.type == eventKey)
            if(condition != undefined) {
                return Stage.processEventSteps(stage, condition.events)
            }
        }

        if(encounter.events != undefined
        && encounter.events[eventKey] != undefined) {
            let events = encounter.events[eventKey]
            return Stage.processEventSteps(stage, events)
        }

        return []
    }
    // accepts: an array of either events or subarrays of events.
    // outputs: an new array of all events
    static flattenEventSteps(events) {
        let output = []
        events.forEach((event) => {
            if(event instanceof Array) {
                output = output.concat(Stage.flattenEventSteps(event))
            } else {
                output.push(event)
            }
        })
        return output
    }
    // inputs in an array of steps.
    // you can embed those steps in subarrays.
    // you can return those steps from jit functions (passed the stage).
    // you can also calculate the entire top-level array using a jit function.
    static processEventSteps(alphastage, inputs) {
        let steps = []


        if(inputs == undefined) return []
        if(inputs instanceof Function) {
            inputs = inputs(alphastage)
        }
        if(inputs instanceof Array != true) {
            inputs = [inputs]
        }
        inputs.forEach((input) => {
            if(input instanceof Function) {
                input = input(alphastage)
            }
            if(input == undefined) {
                return undefined
            }
            if(input instanceof Array == false) {
                input = new Array(input)
            }
            // TODO: Make this recursive for functions and arrays all the way down!!
            input = Stage.flattenEventSteps(input)

            input.forEach((step) => {
                if(step == undefined) return

                step = Step.copy(step)

                step.alphastage = alphastage
                step = Step.instantiate(step)
                alphastage = step.omegastage

                steps.push(step)
            })
        })

        return steps
    }

    ////////////////
    // YOUR TURN //
    //////////////

    static calculateActions(stage, force) {
        const mark = Speedtest.mark("Actions", "Stage.calculateActions")

        if(stage.hasPerformedActionCalculation == true && !force) {
            return
        }

        Objdict.forEach(stage.units, (unit) => {
            if(Zone.isInBounds(stage.encounters[stage.currentEncounter || 1].zone, unit.position)) {
                unit.actionmap = Unit.calculateActions(unit.key, stage)
                // DEUBG: We're not calculating it for all units, depending on affiliation.
                // if(unit.affiliation == "good") {
                //     unit.actionmap = Unit.calculateActions(unit.key, stage)
                    // DEBUG // We're now calculating this just-in-time for when you hover over this actionmap option.
                    // Object.values(unit.actionmap).forEach((actionlist) => actionlist.forEach((action) => {
                    //     Stage.calculateNextTurn(action.omegastage)
                    // }))
                // }
            }
        })
        // // We're removing this and only calculating these just before you end your turn.
        // Stage.calculateNextTurn(stage) // DEBUG

        stage.hasPerformedActionCalculation = true
        Stage.calculateLight(stage)

        mark()

        return stage
    }
    static calculateLight(stage) {
        stage.light = {}
        Objdict.forEach(stage.units, (unit) => {
            if(unit.affiliation != "bad") return
            if(unit.type == "zone") return

            let actionmap = unit.actionmap
            // if(stage.nextTurn != undefined
            // && stage.nextTurn.aiActions != undefined
            // && stage.nextTurn.aiActions[unit.key] != undefined
            // && stage.nextTurn.aiActions[unit.key].actionmap != undefined) {
            //     actionmap = stage.nextTurn.aiActions[unit.key].actionmap
            // }
            // if(actionmap == undefined) return

            Objdict.forEach(actionmap, (actionlist, positionKey) => {
                // const action = Selection.findActionInActionlistToActuallyUse({unit, actionlist, "options": {"ignoreActiveSkill": true}})
                // if(action == undefined) return
                stage.light[positionKey] = true // action.position
            })
        })
    }

    static getScore(stage) {
        let score = undefined
        Object.values(stage.units).forEach((unit) => {
            if(unit.affiliation == "good"
            && unit.score != undefined) {
                score = score || 0
                if(unit.isDead != true
                && unit.hasBeenRemoved != true) {
                    score += unit.score
                }
            }
        })
        return score
    }
}

// const directions = [{"x": +1}, {"x": -1}, {"y": +1}, {"y": -1}]
// // TODO: merge this with utilities/Directions.js? Pull them from Geometry.north/etc?
//
